import { useTypingAnimation } from "~/lib/hooks";

// A common hook to ensure consistency across Ask Fellow
const useAskFellowTypingAnimation = () => {
	const placeholderTexts = [
		"What were the key decisions made?",
		"Who has action items from this meeting?",
		"What were the main takeaways?",
		"Did we resolve the open questions?",
	];
	return useTypingAnimation(placeholderTexts);
};

export default useAskFellowTypingAnimation;
